'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-browser.routes';

export class SurveyBrowserComponent {
  constructor(SurveysService, Auth, $state, dialogs, $stateParams, $uibModal, SurveyResultsService, $scope, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.SurveysService = SurveysService;
    this.SurveyResultsService = SurveyResultsService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$scope = $scope;
    this.surveyId = $stateParams.id;
    this.model = {};

    this.cursor = 0;
    this.maxCursor = 0;

    this.data = [];

    if (this.surveyId) {

      this.SurveysService.get({id: this.surveyId}, (survey) => {
        this.survey = survey;

        let schema = {
          "type": "object",
          "properties": {}
        };

        let form = [];

        for (let i = 0; i < survey.questions.length; i++) {
          let key = "question_" + i;

          switch (survey.questions[i].type) {
            case 'text':
              schema.properties[key] = {
                "title": survey.questions[i].question,
                "type": "string"
              };
              break;
            case 'select-one':
              schema.properties[key] = {
                "title": survey.questions[i].question,
                "type": "string",
                enum: survey.questions[i].answers
              };
              break;
            case 'select-many':
              schema.properties[key] = {
                "title": survey.questions[i].question,
                "type": "array",
                "items": {
                  enum: survey.questions[i].answers
                }
              };
              break;
          }
          form.push(key);
        }

        this.csvHeader = survey.questions.map(q => q.question);

        this.schema = schema;
        this.form = form;

        this.SurveyResultsService.getResultsBySurvey({survey: this.surveyId}, results => {
          let data = results.filter(result => result.hasOwnProperty("answers"));
          this.data = data.reverse();
          this.maxCursor = this.data.length ? this.data.length - 1 : 0;
          this.move("first");
        });

        }, err => {
        console.log("Could not retrieve survey from server.")
      })

    }

  }

  loadCsvData() {
    return this.data.map(response => response.answers);
  }

  move(pos) {
    switch (pos) {
      case 'first':
        this.cursor = 0;
        break;
      case 'prev':
        this.cursor--;
        break;
      case 'next':
        this.cursor++;
        break;
      case 'last':
        this.cursor = this.maxCursor;
        break;
    }

    this.model = this.data[this.cursor];
  }
}

export default angular.module('conduu.surveyBrowser', [uiRouter])
  .config(routes)
  .component('surveyBrowser', {
    template: require('./survey-browser.html'),
    controller: SurveyBrowserComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/browser/survey-browser.component.js